export const categories = [
  {
    name: '本地生活',
    slug: 'local-life',
    description: '关注城市生活方方面面，提供最接地气的本地服务信息与生活指南',
    icon: 'ri-building-2-line',
  },
  {
    name: '商务资讯',
    slug: 'business',
    description: '汇集最新商业动态、市场趋势与投资信息，助力您的商业决策',
    icon: 'ri-briefcase-line',
  },
  {
    name: '休闲娱乐',
    slug: 'entertainment',
    description: '发现城市中的精彩去处，影院、演出、展览等休闲娱乐资讯一网打尽',
    icon: 'ri-movie-line',
  },
  {
    name: '美食探店',
    slug: 'food',
    description: '探寻城市美食地图，从街头小吃到精致餐厅，带您品味舌尖上的城市',
    icon: 'ri-restaurant-line',
  },
  {
    name: '旅游出行',
    slug: 'travel',
    description: '分享旅行攻略、景点推荐和出行贴士，让您的旅途更加顺畅惬意',
    icon: 'ri-flight-takeoff-line',
  },
  {
    name: '科技数码',
    slug: 'tech',
    description: '追踪科技前沿动态，数码产品评测与行业深度分析，科技改变生活',
    icon: 'ri-smartphone-line',
  },
];